import { Box, styled } from "@mui/material";

export const StyledExpoItem = styled(Box)(({ theme }) => ({
  width: "100%",
  background: theme.color.background,
  boxShadow: `0px 0px 3px 3px ${theme.contrast.lighter}`,
  borderRadius: "10px",
  userSelect: "none",
  ".expoItemHeader": {
    height: "4rem",
    paddingInline: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    h3: {
      fontWeight: "bold",
      color: theme.color.dark,
    },
    svg: {
      color: theme.color.contrastColor,
    },
  },
  ".expoItemContent": {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    paddingInline: "2rem",
    paddingBottom: "2rem",
    ".imageWrapper": {
      width: "20rem",
      borderRadius: "10px",
      height: "20rem",
      img: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    ".expoItemHeader": {
      height: "fit-content",
      padding: "1rem",
      h3: {
        fontSize: "1rem",
        lineHeight: "1.6rem",
        width: "80%",
      },
    },
  },
}));
